import * as React from "react";
import { ICouncil } from "src/interfaces";
import RiskSlider from './RiskSlider';
import CouncilRiskCard from './CouncilRiskCard';

interface IProps {
  councils: ICouncil[];
  year: string;
}

export default class RelativeRisk extends React.PureComponent<IProps, {}> {
  public render() {
    return (
      <RiskSlider>
        {this.props.councils.map((council, index) => (

          <CouncilRiskCard
            key={ index }
            ordinal={ index + 1 }
            year={ this.props.year }
            council={ council }
          />

        ))}
      </RiskSlider>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilSustainability/RelativeRisk.tsx